import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
import FormPageHeader from "../utilities/FormPageHeader";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Select from "react-select";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  Switch,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Checkbox,
} from "@mui/material";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkSpecialChar, checkString } from "../utilities/FormValidation";
import customStyles from "app/shared-components/SelectCustomStyle";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import AgGridTable from "../utilities/AgGridTable";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import FrontOptionsView from "./front-options/FrontOptionsView";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import AddIcon from "@mui/icons-material/Add";
import DialogBox from "../utilities/DialogBox";
import BundleProductOptions from "./bundle-product-options/BundleProductOptions";
import imagePlaceHolder from "src/assets/no_image.png";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";

const MaterialMasterForm = () => {
  const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
  const rangeVariationUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.rangeVariations}`;
  const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.carcasses}`;
  const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.handles}`;
  const productUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.products}`;
  const productFrontOptionUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.productsRangeVariation}`;
  const productBundleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.productBundles}`;
  const posMaterialUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.posMaterials}`;
  const genericProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.generics}`;
  const addRangeVariationsProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.addRangeVariations}`;
  const updateRangeVariationsProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.updateRangeVariations}`;
  const PGUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
  const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;

  const [tabValue, setTabValue] = useState(0);
  const { id } = useParams();
  const navigate = useNavigate();
  const gridRef = useRef();
  const [bundleProductData, setBundleProductData] = useState([]);
  const [rangeOptionData, setRangeOptionData] = useState([]);
  const [frontOptionData, setFrontOptionData] = useState([]);
  const [error, setError] = useState("");
  const [selectedRowsId, setSelectedRowsId] = useState([]);
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [saveVariationDisable, setSaveVariationDisable] = useState(true);
  const [open, setOpen] = useState(false);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [productList, setProductList] = useState([]);
  const [rangeList, setRangeList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [modalName, setModalName] = useState();
  const [productType, setProductType] = useState("");
  const [label, setLabel] = useState("Product");
  const [priceGroup, setPriceGroup] = useState("");
  const [priceGroupLink, setPriceGroupLink] = useState("");
  const [validFrom, setValidFrom] = useState(null);
  const [validUntil, setValidUntil] = useState(null);
  const [factoryVendors, setFactoryVendors] = useState([]);
  const [factoryVendorLink, setFactoryVendorLink] = useState("");
  // const [category, setCategory] = useState("");
  const [deletedProduct, setDeletedProduct] = useState([]);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [designYear, setDesignYear] = useState("");
  const [productImage, setProductImage] = useState(null);
  const [productImageName, setProductImageName] = useState("");
  const [variationImageName, setVariationImageName] = useState("");
  const [productId, setProductId] = useState("");
  const [variationId, setVariationId] = useState("");
  const [active, setActive] = useState(true);
  const [newProduct, setNewProduct] = useState(true);
  const [saveResponse, setSaveResponse] = useState(false);
  const [view, setView] = useState("module");
  const [selectedVariation, setSelectedVariation] = useState([]);
  const [selectedRanges, setSelectedRanges] = useState([]);
  const [selectedBundleProducts, setSelectedBundleProducts] = useState([]);
  const [variationData, setVariationData] = useState([]);
  const [editData, setEditData] = useState();
  const [editVariationData, setEditVariationData] = useState([]);
  const [editRangeList, setEditRangeList] = useState([]);
  const [editProductList, setEditProductList] = useState([]);
  const [disable, setDisable] = useState(true);
  const [yearList, setYearList] = useState();
  const [variationError, setVariationError] = useState({});
  const [isLacquered, setIsLacquered] = useState(false)
  // const [year, setYear] = useState();
  const initialValue = {
    productId: "",
    productName: "",
    color: "",
    vendor: [],
    validUntil: null,
    imageUrl: null,
    active: true,
    isNew: true,
    _class: "Front Options",
  };
  const [variationValue, setVariationValue] = useState(initialValue);

  const [columnDefs, setColumnDefs] = useState([
    { field: "_class", enableRowGroup: true, headerName: "PRODUCT TYPE" },
    { field: "productId", headerName: "PRODUCT ID" },
    { field: "productName", enableRowGroup: true, headerName: "PRODUCT NAME" },
    { field: "vendor", headerName: "VENDOR" },
  ]);

  const productData = [
    { value: "ranges", label: "Range" },
    { value: "carcasses", label: "Carcass" },
    { value: "handles", label: "Handle" },
    { value: "pOSMaterials", label: "Pos Material" },
    { value: "productBundles", label: "Bundled Product" },
    { value: "generics", label: "Generic" },
    { value: "rangeVariations", label: "Front Options" }
  ];

  const handleOpen = () => {
    if (productType === "ranges") {
      if (variationId) {
        setVariationValue(initialValue);
        setVariationImageName("");
      }
      setOpen(true);
      setModalName("Add Front Options");
    }
  };

  const DeleteDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleClose = () => {
    setVariationValue(initialValue);
    setOpen(false);
    setOpenDeleteDialog(false);
    setVariationImageName("");
  };
  const handlePreviewClose = () => {
    setPreviewDialog(false);
  };
  const handleCheckboxChange = (event) => {
    setIsLacquered(event.target.checked);
  };
  const handleSubmit = async () => {
    setCheckSubmit(true);
    // const validFromDate = moment(validFrom).format('YYYY-MM-DD');
    // const validUntilDate = moment(validUntil).format('YYYY-MM-DD');

    let model = {
      productId: productId,
      productName: productName,
      vendor: factoryVendorLink.length > 0 ? factoryVendorLink : null,
      imageUrl: productImage,
      productDescription: productDescription,
      validFrom: validFrom ? moment(validFrom).format('YYYY-MM-DD') : '',
      validUntil: validUntil ? moment(validUntil).format('YYYY-MM-DD') : '',
      priceGroup: priceGroupLink,
      designYear: designYear,
      active: active,
      isNew: newProduct,
    };

    try {
      if (id) {
        setSaveDisable(true);
        if (productType === "ranges") {
          if (
            productType &&
            productId &&
            !validError.productId &&
            productName &&
            !validError.productName &&
            !validError.validUntil &&
            priceGroupLink
          ) {
            const variationModel = variationData.map(
              (variation) => {
                const variationLink = `${rangeVariationUrl}/${variation.id}`
                return variationLink;
              }
            );
            model.lacquered = isLacquered;
            model.variations = variationModel;
            const res = await OAuthService.updateData(rangeUrl, id, model);
            if (res.status === 200) {
              setSuccessMsg("Data Updated Successfully");
              setSnackState(true);
              setTimeout(() => {
                navigate("/materialMasters");
              }, 800);
            }
          }
        } else if (productType === "carcasses") {
          const res = await OAuthService.updateData(carcassUrl, id, model);
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "handles") {
          const res = await OAuthService.updateData(handleUrl, id, model);
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "pOSMaterials") {
          const res = await OAuthService.updateData(posMaterialUrl, id, model);
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "productBundles") {
          delete model.priceGroup;
          const productModel = productList.map((product) => product?._links?.self?.href);
          model.products = productModel;
          const res = await OAuthService.updateData(
            productBundleUrl,
            id,
            model
          );
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "generics") {
          const res = await OAuthService.updateData(
            genericProductUrl,
            id,
            model
          );
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "rangeVariations") {
          delete model.priceGroup;
          model = {
            ...model,
            range: rangeList?.map((range) => range.id),
            id: id,
            vendor: model.vendor?.map((vendor) => {
              const vendorArr = vendor.split('/');
              return vendorArr[vendorArr.length - 1];
            })
          }
          const res = await OAuthService.updateData(
            updateRangeVariationsProductUrl,
            id,
            model
          );
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        }
      } else {
        setSaveDisable(true);
        if (productType === "ranges") {
          const res = await OAuthService.addData(rangeUrl, model);
          if (res.status === 201) {
            if (res.data.id && variationData.length > 0) {
              const variationModel = variationData.map(
                // const variationLink = 
                (variation) => {
                  const variationLink = `${rangeVariationUrl}/${variation.id}`
                  return variationLink;
                }
              );
              model.variations = variationModel;
              model.lacquered = isLacquered;
              await OAuthService.updateData(rangeUrl, res.data.id, model);
            }
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "carcasses") {
          const res = await OAuthService.addData(carcassUrl, model);
          if (res.status === 201) {
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "handles") {
          const res = await OAuthService.addData(handleUrl, model);
          if (res.status === 201) {
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "pOSMaterials") {
          const res = await OAuthService.addData(posMaterialUrl, model);
          if (res.status === 201) {
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "productBundles") {
          delete model.priceGroup;
          const res = await OAuthService.addData(productBundleUrl, model);
          if (res.status === 201) {
            if (res.data.id && productList.length > 0) {
              const productModel = productList.map(
                (product) => {
                  product?._links?.self?.href
                }
              );
              model.products = productModel;
              await OAuthService.updateData(
                productBundleUrl,
                res.data.id,
                model
              );
            }
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "generics") {
          const res = await OAuthService.addData(genericProductUrl, model);
          if (res.status === 201) {
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        } else if (productType === "rangeVariations") {
          model = {
            ...model,
            range: rangeList?.map((range) => range.id),
            vendor: model.vendor?.map((vendor) => {
              const vendorArr = vendor.split('/');
              return vendorArr[vendorArr.length - 1];
            })
          }
          delete model.priceGroup;
          const res = await OAuthService.addData(
            addRangeVariationsProductUrl,
            model
          );
          if (res.status === 200) {
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              navigate("/materialMasters");
            }, 800);
          }
        }
      }
    } catch (error) {
      setError(error.message);
      setSaveDisable(false);
      return;
    }
  };

  const getProduct = async () => {
    let edits = {};
    try {
      const result = await OAuthService.getEditData(productUrl, id);
      const product = result?.data;
      const Type = product?._links?.self?.href.split("/", 5).pop();
      const productLabel = productData.find((item) => item.value === Type);
      setLabel(productLabel?.label);
      const vendorsUrl = `${productBundleUrl}/${id}/vendor`;
      const variationsUrl = `${rangeUrl}/${id}/variations`;
      const priceGroupUrl = `${rangeUrl}/${id}/priceGroup`;
      const productsUrl = `${productBundleUrl}/${id}/products`;;

      const getVendor = await OAuthService.getList(vendorsUrl);
      const vendors = getVendor.data._embedded.factoryVendors;
      const vendorValue = vendors.map((vendor) => {
        const link = `${factoryVendorUrl}/${vendor.id}`
        return link;
      });

      if (Type === 'rangeVariations') {
        const result = await await OAuthService.getEditData(productFrontOptionUrl, id);
        let rangeData = [...result.data?.range];
        rangeData = rangeData.map((range) => {
          return {
            ...range,
            vendor: range.vendor.map((vendor) => `${vendor.name} ${vendor.shortKey}`)?.join()
          }
        });
        setRangeList(rangeData);
        setEditRangeList(rangeData);
      }

      if (product?.imageUrl !== null) {
        const imageString = product?.imageUrl?.toString()?.split(";", 1)?.pop();
        const imageType = imageString?.split("/")?.pop();
        const imageName = `${product.productName}.${imageType}`;
        setProductImageName(imageName);
      }

      if (variationsUrl) {
        const getVariations = await OAuthService.getList(variationsUrl);
        let variations = getVariations.data._embedded.rangeVariations;
        variations = await Promise.all(
          variations.map(async (variation) => {
            variation.productName = variation.productName.toUpperCase();
            const vendorsUrl = `${rangeVariationUrl}/${id}/vendor`;
            const getVendor = await OAuthService.getList(vendorsUrl);
            const vendors = getVendor?.data?._embedded?.factoryVendors;
            const vendorName = vendors.map((vendor) => {
              const name = vendor.name;
              const shortKey = vendor.shortKey;
              const merge = `${name} ${shortKey}`;
              return merge;
            });
            variation.vendor = vendorName.join(" , ");
            return variation;
          })
        );

        setVariationData(variations);
        setEditVariationData(JSON.parse(JSON.stringify(variations)));
      }

      if (priceGroupUrl) {
        const getPriceGroup = await OAuthService.getList(priceGroupUrl);
        const PgId = getPriceGroup.data.pgId;
        const priceGroupValue = `${PGUrl}/${PgId}`;
        setPriceGroupLink(priceGroupValue);
        edits = { ...edits, priceGroupLink: priceGroupValue }
      }
      if (productsUrl) {
        const getProducts = await OAuthService.getList(productsUrl);
        const ranges = getProducts?.data?._embedded?.ranges
          ? getProducts?.data?._embedded?.ranges
          : [];
        const rangeVariations = getProducts.data._embedded.rangeVariations
          ? getProducts.data._embedded.rangeVariations
          : [];
        const handles = getProducts.data._embedded.handles
          ? getProducts.data._embedded.handles
          : [];
        const carcasses = getProducts.data._embedded.carcasses
          ? getProducts.data._embedded.carcasses
          : [];
        const pOSMaterials = getProducts.data._embedded.pOSMaterials
          ? getProducts.data._embedded.pOSMaterials
          : [];
        const generics = getProducts.data._embedded.generics
          ? getProducts.data._embedded.generics
          : [];
        const productBundles = getProducts.data._embedded.productBundles
          ? getProducts.data._embedded.productBundles
          : [];
        let products = [
          ...ranges,
          ...rangeVariations,
          ...carcasses,
          ...handles,
          ...productBundles,
          ...pOSMaterials,
          ...generics,
        ];

        products = await Promise.all(
          products.map(async (product) => {
            const capsProduct = product.productName.toUpperCase();
            product.productName =
              product.isNew === true ? `${capsProduct} (new)` : capsProduct;
            const vendorsUrl = `${rangeVariationUrl}/${id}/vendor`;
            const getVendor = await OAuthService.getList(vendorsUrl);
            const vendors = getVendor?.data?._embedded?.factoryVendors;
            const vendorName = vendors.map((vendor) => {
              const name = vendor.name;
              const shortKey = vendor.shortKey;
              const merge = `${name} ${shortKey}`;
              return merge;
            });
            product.vendor = vendorName.join(" , ");
            return product;
          })
        );
        setProductList(products);
        setEditProductList(products);
      }
      setProductType(Type);
      setProductId(product?.productId);
      setProductName(product?.productName);
      setFactoryVendorLink(vendorValue);
      setProductDescription(product?.productDescription);
      setValidFrom(product?.validFrom);
      setNewProduct(product?.isNew);
      setIsLacquered(product?.lacquered)
      setProductImage(product?.imageUrl);
      setValidUntil(product?.validUntil);
      setDesignYear(product?.designYear);
      setActive(product?.active);
      edits = {
        ...edits,
        type: Type,
        productId: product?.productId,
        productName: product?.productName,
        vendorValue: vendorValue,
        productDescription: product?.productDescription,
        validFrom: product?.validFrom,
        isNew: product?.isNew,
        imageUrl: product?.imageUrl,
        validUntil: product?.validUntil,
        designYear: product?.designYear,
        lacquered: product?.lacquered,
        active: product?.active,
      }
      setEditData(edits);
    } catch (error) {
      setError(error.message);
    }
  };
  {
    /*------------------------------Get Vendors list----------------------------------------*/
  }

  const getVendorsList = async () => {
    try {
      const list = await OAuthService.getList(factoryVendorUrl + `?size=1000`);
      let factoryVendorData = list.data?._embedded?.factoryVendors;
      factoryVendorData = factoryVendorData.map((vendor) => {
        const link = `${factoryVendorUrl}/${vendor.id}`
        return {
          label: vendor.name,
          value: link,
        };
      });
      setFactoryVendors(factoryVendorData);
    } catch (error) {
      setError(error.message);
    }
  };

  {
    /*------------------------------Get Price Group----------------------------------------*/
  }

  const getPriceGroupList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
    try {
      const list = await OAuthService.getList(url + `?size=1000&sort=pgId,asc`);
      let priceGroup = list.data?._embedded?.priceGroups;
      const result = priceGroup?.map((value) => {
        const priceGrpLink = `${PGUrl}/${value.pgId}`
        return {
          label: value.pgId,
          value: priceGrpLink,
        };
      });
      setPriceGroup(result);
    } catch (error) {
      setError(error.message);
    }
  };

  const onGridReady = useCallback(
    (params) => {
      // setGridApi(params);
      var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
      columnToolPanel.expandColumnGroups();
      // gridRef.current.columnApi.setColumnVisible("_class", false);
      if (productType === "ranges") {
        gridRef.current.columnApi.setColumnVisible("_class", false);
      } else {
        gridRef.current.columnApi.setColumnVisible("_class", true);
      }
    },
    [productList, variationData, productType]
  );

  useEffect(() => {
    if (id) {
      getProduct();
      setHideDelete(false);
    }
    getVendorsList();
    getPriceGroupList();
  }, []);

  const handleDelete = async () => {
    if (id) {
      try {
        await OAuthService.deleteData(productUrl, id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
      } catch (error) {
        setError(error.message);
      }
    }
    setTimeout(() => {
      navigate("/materialMasters");
    }, 800);
  };

  const handleCancel = () => {
    navigate("/materialMasters");
  };

  const handleProductImageChange = (e) => {
    const file = e.target.files[0];
    setProductImageName(file.name);
    // setProductImageName([...productImage, file.name])

    var reader = new FileReader();
    reader.onload = function (upload) {
      setProductImage([upload.target.result]);
    };
    reader.readAsDataURL(file);
  };

  const removeImage = (type) => {
    if (type === "range") {
      setProductImageName("");
      setProductImage(null);
    } else {
      setVariationValue({ ...variationValue, ["imageUrl"]: null });
      setVariationImageName("");
    }
    // setVariationValue({ ...variationValue, ["image"]: "" });
  };

  // ------------------------------------------------------------------------------

  const handleValidFromChange = (newValue) => {
    setValidFrom(newValue);
  };
  const handleValidUntilChange = (newValue) => {
    const until = newValue ? moment(newValue).format('YYYY-MM-DD') : '';
    setValidUntil(newValue ? moment(newValue).format('YYYY-MM-DD') : '');
    const currentDate = new Date().setHours(0, 0, 0, 0);
    if (currentDate > new Date(until)) {
      setActive(false);
    } else if (currentDate <= new Date(until)) {
      setActive(true);
    }
  };

  const handleProductChange = (data) => {
    setProductType(data.value);
    setLabel(data.label);
  };
  // const handleCategoryChange = (data) => {
  //     setCategory(data.value);
  // };

  const handlePriceGroupChange = (data) => {
    setPriceGroupLink(data.value);
  };

  function handleTabChange(event, value) {
    setTabValue(value);
  }
  const handleVendorChange = (value) => {
    const vendor = value.map((row) => {
      return row.value;
    });
    setFactoryVendorLink(vendor);
  };

  const handleViewChange = (event, nextView) => {
    if (nextView === "module") {
      // selectedRowsId.length = 0;
      setSelectedRowsId([])
    }
    if (nextView === "list") {
      // selectedBundleProducts.length = 0;
      setSelectedBundleProducts([]);
      setSelectedRanges([]);
      setSelectedVariation([])
    }
    setView(nextView);
  };


  // -------------------------front options (variation)-------------------------

  const handleVariationChange = (event, key) => {
    if (key === "vendor") {
      const vendorValue = event.map((row) => {
        return row.value;
      });
      setVariationValue((prevValue) => ({
        ...prevValue,
        vendor: vendorValue,
      }));
    } else {
      setVariationValue({
        ...variationValue,
        [event.target.name]: event.target.value.toUpperCase(),
      });
    }
  };

  const handleVariationDateChange = (newValue, valid) => {
    setVariationValue({ ...variationValue, [valid]: newValue ? moment(newValue).format('YYYY-MM-DD') : '' });
    const currentDate = new Date().setHours(0, 0, 0, 0);
    if (currentDate > new Date(moment(newValue).format('YYYY-MM-DD'))) {
      setVariationValue({
        ...variationValue,
        active: false,
      });
    } else if (currentDate <= new Date(newValue ? moment(newValue).format('YYYY-MM-DD') : '')) {
      setVariationValue({
        ...variationValue,
        active: true,
      });
    }
  };

  const handleVariationImageChange = (e) => {
    const file = e.target.files[0];
    setVariationImageName(file.name);

    var reader = new FileReader();
    reader.onload = function (upload) {
      setVariationValue({
        ...variationValue,
        [e.target.name]: [upload.target.result],
      });
    };
    reader.readAsDataURL(file);
  };

  const showOption = () => {
    // handleSubmit();
    setCheckSubmit(true);
    if (id) {
      if (
        (productType &&
          productId &&
          !validError.productId &&
          productName &&
          !validError.productName &&
          !validError.validUntil) ||
        priceGroupLink
      ) {
        setSaveResponse(true);
      }
    } else {
      setSaveResponse(true);
    }
  };

  const handleVariationSubmit = async () => {
    if (variationId) {
      let model = {
        ...variationValue,
        range: rangeList?.map((range) => range.id),
        vendor: variationValue.vendor?.map((vendor) => {
          const vendorArr = vendor.split('/');
          return vendorArr[vendorArr.length - 1];
        })
      }
      delete model._links;
      const res = await OAuthService.updateData(
        updateRangeVariationsProductUrl,
        variationId,
        model
      );
      const data = variationData.map((item) => {
        if (item.id === res.data.id) {
          item = res.data;
        }
        return item;
      });
      setSuccessMsg("Data Updated Successfully");
      setSnackState(true);
      setOpen(false);
      setVariationData(data);
      setTimeout(() => {
        setSnackState(false);
      }, 1000);
    } else {
      let model = {
        ...variationValue,
        range: rangeList?.map((range) => range.id),
        vendor: variationValue.vendor?.map((vendor) => {
          const vendorArr = vendor.split('/');
          return vendorArr[vendorArr.length - 1];
        })
      }
      const res = await OAuthService.addData(addRangeVariationsProductUrl, model);
      let data = res.data;
      const vendorsUrl = `${rangeVariationUrl}/${id || data?.id}/vendor`;
      const getVendor = await OAuthService.getList(vendorsUrl);
      const vendors = getVendor?.data?._embedded?.factoryVendors;
      const vendorName = vendors.map((vendor) => {
        const name = vendor.name;
        const shortKey = vendor.shortKey;
        const merge = `${name} ${shortKey}`;
        return merge;
      });
      data.vendor = vendorName.join(" , ");
      setVariationData([...variationData, data]);
      setVariationValue(initialValue);
      setVariationImageName("");
      setSuccessMsg("Data saved Successfully");
      setSnackState(true);
      setOpen(false);
      setTimeout(() => {
        setSnackState(false);
      }, 1000);
    }
  };

  const handleChangeSelected = (checked, id, value) => {
    if (checked) {
      if (productType === "ranges") {
        setSelectedVariation([...selectedVariation, id]);
      } else if (productType === 'productBundles') {
        setSelectedBundleProducts([...selectedBundleProducts, id]);
      } else {
        setSelectedRanges([...selectedRanges, id]);
      }
      document.addEventListener("keydown", function (event) {
        if (event.key === "Delete") {
          event.preventDefault();
          setOpenDeleteDialog(true);
        }
      });
    } else {
      const filterVariation = selectedVariation.filter((item) => item !== id);
      setSelectedVariation(filterVariation);
      const filterBundle = selectedBundleProducts.filter((item) => item !== id);
      setSelectedBundleProducts(filterBundle);
      const filterRanges = selectedRanges.filter((item) => item !== id);
      setSelectedRanges(filterRanges);
    }
  };

  const getVariation = async (id) => {
    if (id) {
      setOpen(true);
      setModalName("Edit Front Options");
      const result = await OAuthService.getEditData(rangeVariationUrl, id);
      let variation = result.data;
      const vendorsUrl = `${rangeVariationUrl}/${id}/vendor`;
      const getVendor = await OAuthService.getList(vendorsUrl);
      const vendors = getVendor?.data?._embedded?.factoryVendors;
      variation.vendor = vendors.map((vendor) => {
        const link = `${factoryVendorUrl}/${vendor.id}`
        return link;
      }
      );

      if (variation?.imageUrl !== null) {
        const imageString = variation?.imageUrl.toString().split(";", 1).pop();
        const imageType = imageString?.split("/").pop();
        const imageName = `${variation.productName}.${imageType}`;
        setVariationImageName(imageName);
      }
      setVariationId(id);
      setVariationValue(variation);
      setEditVariationData(JSON.parse(JSON.stringify(variation)));
    }
  };
  const handleProductDelete = async () => {
    if (selectedRowsId.length > 0) {
      if (variationData.length > 0) {
        const result = variationData.filter(
          (variation) => -1 === selectedRowsId.indexOf(variation.id)
        );
        const deleteProduct = variationData.filter((variation) =>
          selectedRowsId.includes(variation.id)
        );
        setDeletedProduct(deleteProduct);
        setVariationData(result);
        setSelectedRowsId([]);
      } else if (productData.length > 0) {
        const result = productList.filter(
          (product) => -1 === selectedRowsId.indexOf(product.id)
        );
        const deleteProduct = productList.filter((product) =>
          selectedRowsId.includes(product.id)
        );
        setDeletedProduct(deleteProduct);
        setProductList(result);
        setSelectedRowsId([]);
      } else {
        const result = rangeList.filter(
          (variation) => -1 === selectedRowsId.indexOf(variation.id)
        );
        const deleteProduct = selectedRowsId.filter((variation) =>
          selectedRowsId.includes(variation.id)
        );
        setDeletedProduct(deleteProduct);
        setRangeList(result);
        setSelectedRowsId([]);
      }
    } else {
      if (productType === "ranges") {
        const result = variationData.filter(
          (variation) => -1 === selectedVariation.indexOf(variation.id)
        );
        const deleteProduct = variationData.filter((variation) =>
          selectedVariation.includes(variation.id)
        );
        setDeletedProduct(deleteProduct);
        setVariationData(result);
        setSelectedVariation([]);
      } else if (productType === 'productBundles') {
        const result = productList.filter(
          (product) => -1 === selectedBundleProducts.indexOf(product.id)
        );
        const deleteProduct = productList.filter((product) =>
          selectedBundleProducts.includes(product.id)
        );
        setDeletedProduct(deleteProduct);
        setProductList(result);
        setSelectedBundleProducts([]);
      } else {
        const result = rangeList.filter(
          (range) => -1 === selectedRanges.indexOf(range.id)
        );
        const deleteProduct = rangeList.filter((range) =>
          selectedRanges.includes(range.id)
        );
        setDeletedProduct(deleteProduct);
        setRangeList(result);
        setSelectedRanges([]);
      }
    }
    setOpenDeleteDialog(false);
  };

  // -------------------------Bundle Products drag and drop-------------------------

  const dragover_handler = (event) => {
    event.preventDefault();
    var dragSupported = event.dataTransfer.types.length;
    setDeletedProduct([]);

    if (dragSupported) {
      event.dataTransfer.dropEffect = "move";
    }
  };

  const drop_handler = (event, side) => {
    event.preventDefault();
    var jsonData = event.dataTransfer.getData("application/json");
    let dragProductItem = JSON.parse(jsonData);
    const type = dragProductItem._class;
    if (productType === "ranges") {
      if (selectedProducts.length > 0) {
        const product = [...variationData, ...selectedProducts];
        setVariationData(product);
        if (side === "right") {
          setSelectedProducts([]);
        }
      } else {
        const product = [...variationData, dragProductItem];
        setVariationData(product);
      }
    } else if (productType === "productBundles") {
      if (selectedProducts.length > 0) {
        const product = [...productList, ...selectedProducts];
        setProductList(product);
        if (side === "right") {
          setSelectedProducts([]);
        }
      } else {
        const product = [...productList, dragProductItem];
        setProductList(product);
      }
    } else {
      if (selectedRanges.length > 0) {
        const range = [...rangeList, ...selectedRanges];
        setRangeList(range);
        if (side === "right") {
          setSelectedProducts([]);
        }
      } else {
        const range = [...rangeList, dragProductItem];
        setRangeList(range);
      }
    }
  };

  const onSelectionChanged = (params) => {
    let row = params.api.getSelectedRows();
    row = row.map((item) => item.id);
    setSelectedRowsId(row);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Delete") {
        event.preventDefault();
        setOpenDeleteDialog(true);
      }
    });
  };

  const onBundleProductOptionChanged = (params) => {
    let row = params.api.getSelectedRows();
    setSelectedProducts(row);
  };

  // ----------------------------------------------------------------------
  useEffect(() => {
    if (productType && productId && productName) {
      if (productType === "ranges" || productType === "productBundles" || productType === 'rangeVariations') {
        if (priceGroupLink && variationData.length > 0 || productList.length > 0 || rangeList.length > 0) {
          if (editData) {
            if (editData?.type !== productType ||
              active !== editData.active ||
              editData.productId !== productId ||
              productName !== editData.productName ||
              priceGroupLink !== editData.priceGroupLink ||
              JSON.stringify(factoryVendorLink) !== JSON.stringify(editData.vendorValue) ||
              validUntil !== editData.validUntil ||
              validFrom !== editData.validFrom ||
              productDescription !== editData.productDescription ||
              designYear !== editData.designYear ||
              newProduct !== editData.isNew ||
              isLacquered !== editData.lacquered ||
              JSON.stringify(productImage) !== JSON.stringify(editData.imageUrl) ||
              JSON.stringify(editVariationData) !== JSON.stringify(variationData) ||
              JSON.stringify(editProductList) !== JSON.stringify(productList) ||
              JSON.stringify(editRangeList) !== JSON.stringify(rangeList)) {
              setSaveDisable(false);
            } else {
              setSaveDisable(true);
            }
          } else {
            setSaveDisable(false);
          }
        } else {
          setSaveDisable(true);
        }
      } else {
        if (editData || editVariationData || editProductList) {
          if (
            editData?.type !== productType ||
            active !== editData.active ||
            editData.productId !== productId ||
            productName !== editData.productName ||
            // priceGroupLink !== editData.priceGroupLink ||
            JSON.stringify(factoryVendorLink) !== JSON.stringify(editData.vendorValue) ||
            validUntil !== editData.validUntil ||
            validFrom !== editData.validFrom ||
            productDescription !== editData.productDescription ||
            designYear !== editData.designYear ||
            newProduct !== editData.isNew ||
            isLacquered !== editData.lacquered ||
            JSON.stringify(productImage) !== JSON.stringify(editData.imageUrl) ||
            JSON.stringify(editVariationData) !== JSON.stringify(variationData) ||
            JSON.stringify(editProductList) !== JSON.stringify(productList)
          ) {
            setSaveDisable(false);
          } else {
            setSaveDisable(true);
          }
        } else {
          setSaveDisable(false);
        }
      }
    } else {
      setSaveDisable(true);
    }
  }, [
    editData,
    productType,
    productId,
    productName,
    factoryVendorLink,
    validFrom,
    validUntil,
    productDescription,
    designYear,
    active,
    newProduct,
    productImage,
    variationData,
    rangeList,
    productList,
    priceGroupLink,
    isLacquered,
  ]);

  useEffect(() => {
    if (
      variationValue.productId &&
      variationValue.productName &&
      !variationError.frontOptionId
    ) {
      // if (editVariationData.length > 0) {
      if (
        JSON.stringify(variationValue) !== JSON.stringify(editVariationData)
      ) {
        setSaveVariationDisable(false);
      } else {
        setSaveVariationDisable(true);
      }
      // } else {
      //   setSaveVariationDisable(false);
      // }
    } else {
      setSaveVariationDisable(true);
    }
  }, [variationValue]);

  useEffect(() => {
    if (
      productType &&
      productId &&
      !validError.productId &&
      productName &&
      !validError.productName &&
      !validError.validUntil
    ) {
      if (productType === "ranges") {
        if (priceGroupLink) {
          setDisable(false);
        } else {
          setDisable(true);
        }
      } else {
        setDisable(false);
      }
    } else {
      setDisable(true);
    }
  }, [productType, productId, productName, validUntil, priceGroupLink]);

  useEffect(() => {
    const cyear = new Date().getFullYear();
    let years = Array.from(new Array(5), (val, index) => {
      return { label: cyear + index, value: cyear + index };
    });
    let Oldyears = Array.from(new Array(10), (val, index) => {
      return { label: cyear - index, value: cyear - index };
    });
    years = years.splice(1);
    let reversed = years.reverse();
    setYearList([...reversed, ...Oldyears]);
  }, []);

  const handleYearChange = (data, action) => {
    setDesignYear(action.action === "clear" ? "" : data.value);
  };

  const handleMoveAllRight = () => {
    if (productType === "ranges") {
      const allRight = variationData.concat(frontOptionData);
      setVariationData(allRight);
      setFrontOptionData([]);
      setSelectedProducts([]);
    } else if (productType === "productBundles") {
      const allRight = productList.concat(bundleProductData);
      setProductList(allRight);
      setBundleProductData([]);
      setSelectedProducts([]);
    } else {
      const allRight = rangeList.concat(rangeOptionData);
      setRangeList(allRight);
      setRangeOptionData([]);
      setSelectedProducts([]);
    }
  }
  // right variations 
  // left frontoptions
  //left checked selectedProducts

  const handleMoveSelectedRight = () => {
    if (productType === "ranges") {
      const selectedRight = variationData.concat(selectedProducts);
      setVariationData(selectedRight);
      const listProduct = frontOptionData.filter((item) => !selectedProducts.includes(item));
      setFrontOptionData(listProduct);
      setSelectedProducts([]);
    } else if (productType === 'productBundles') {
      const selectedRight = productList.concat(selectedProducts);
      setProductList(selectedRight);
      const listProduct = bundleProductData.filter((item) => !selectedProducts.includes(item));
      setBundleProductData(listProduct);
      setSelectedProducts([]);
    } else {
      const selectedRight = rangeList.concat(selectedProducts);
      setRangeList(selectedRight);
      const listRanges = rangeOptionData.filter((item) => !selectedProducts.includes(item));
      setRangeOptionData(listRanges);
      setSelectedProducts([]);
    }

  }

  const handleMoveSelectedLeft = () => {
    if (productType === "ranges") {
      const selectedLeft = variationData.filter((variation) => selectedRowsId.includes(variation.id));
      const leftFrontoptions = frontOptionData.concat(selectedLeft);
      setFrontOptionData(leftFrontoptions);
      const listProduct = variationData.filter((item) => !leftFrontoptions.includes(item));
      setVariationData(listProduct);
      setSelectedRowsId([]);
    } else if (productType === 'productBundles') {
      const selectedLeft = productList.filter((product) => selectedRowsId.includes(product.id));
      const leftProduct = bundleProductData.concat(selectedLeft);
      setBundleProductData(leftProduct);
      const listProduct = productList.filter((item) => !leftProduct.includes(item));
      setProductList(listProduct);
      setSelectedRowsId([]);
    } else {
      const selectedLeft = rangeList.filter((range) => selectedRowsId.includes(range.id));
      const leftRange = rangeOptionData.concat(selectedLeft);
      setRangeOptionData(leftRange);
      const listRange = rangeList.filter((item) => !leftRange.includes(item));
      setRangeList(listRange);
      setSelectedRowsId([]);
    }
  }

  const handleMoveAllLeft = () => {
    if (productType === "ranges") {
      const allLeft = frontOptionData.concat(variationData);
      setFrontOptionData(allLeft);
      setVariationData([]);
      setSelectedRowsId([]);
    } else if (productType === 'productBundles') {
      const allLeft = bundleProductData.concat(productList);
      setBundleProductData(allLeft);
      setProductList([]);
      setSelectedRowsId([]);
    } else {
      const allLeft = rangeOptionData.concat(rangeList);
      setRangeOptionData(allLeft);
      setRangeList([]);
      setSelectedRowsId([]);
    }
  }

  return (
    <div className="w-full overflow-scroll">
      <FormPageHeader
        componentName="Material Master"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        breadCrumbSeperator=">"
        currentPage={id ? `Update ${label}` : `Add ${label}`}
        parentBreadcrumbData={[
          { pageName: "Material Master List", pageLink: "/materialMasters" },
        ]}
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        hideDelete={hideDelete}
        saveDisable={saveDisable}
      >
        <DialogBox
          open={openDeleteDialog}
          handleClose={handleClose}
          handleSumbit={handleProductDelete}
          title={"remove"}
          modual={"materialMasters"}
        />
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className="min-h-0"
        >
          <Tab
            label="General"
            className="pt-0 min-h-0"
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
          {/* <Tab label="Showroom" /> */}
        </Tabs>
      </FormPageHeader>

      <div className="p-16 sm:p-24">
        <div className={tabValue !== 0 ? "hidden" : ""}>
          <Grid container spacing={2}>
            <Grid
              sx={{ minWidth: "45%" }}
            // xs={5.5}
            >
              {saveResponse ? (
                // listing products in grid for drag drop

                <div
                  className="mb-16"
                  style={{
                    resize: "both",
                    overflow: "auto",
                    minHeight: "640px",
                    minWidth: "100%",
                  }}
                >
                  <BundleProductOptions
                    setSaveResponse={setSaveResponse}
                    productList={
                      productType === "ranges" ? variationData : productType === 'productBundles' ? productList : rangeList
                    }
                    deletedProduct={deletedProduct}
                    type={productType}
                    bundleProductData={bundleProductData}
                    setBundleProductData={setBundleProductData}
                    frontOptionData={frontOptionData}
                    setFrontOptionData={setFrontOptionData}
                    rangeOptionData={rangeOptionData}
                    setRangeOptionData={setRangeOptionData}
                    onSelectionChanged={onBundleProductOptionChanged}
                  />
                </div>
              ) : (
                <>
                  <FormControl fullWidth>
                    <Stack className="mb-16">
                      <label>*Select Product Type </label>
                      <Select
                        name="productType"
                        value={
                          productType &&
                          productData &&
                          productData.filter((obj) => productType === obj.value)
                        }
                        onChange={handleProductChange}
                        options={productData}
                        isDisabled={id ? true : false}
                        styles={customStyles(
                          ((checksubmit && !productType) ||
                            validError.productType) &&
                          "#f44336",
                        )}
                        className="select"
                      />
                      <Typography
                        mt={0.5}
                        className="text-[#f44336] text-sm ml-14"
                      >
                        {checksubmit && !productType
                          ? "This field is required"
                          : validError.productType}
                      </Typography>
                    </Stack>

                    {/* <Stack className="mb-16">
                                    <label>Category </label>
                                    <Select name="category"
                                        value={(categories && category) && categories.filter(obj => category?.includes(obj.value))}
                                        onChange={handleCategoryChange}
                                        className="select"
                                        classNamePrefix="select"
                                        options={categories}
                                        isDisabled={id ? true : false}
                                        getOptionLabel={e => (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {e.icon}
                                                <span style={{ marginLeft: 5 }}>{e.label}</span>
                                            </div>
                                        )}
                                        styles={customStyles()}
                                    />
                                    <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !category) ? "This field is required" : validError.category}</Typography>
                                </Stack> */}

                    {productType !== "productBundles" && (
                      <Stack className="mb-16">
                        <label>Select Vendor</label>
                        <Select
                          className="basic-multi-select mb-4"
                          name="name"
                          required
                          value={factoryVendors.filter((obj) =>
                            factoryVendorLink?.includes(obj.value)
                          )}
                          onChange={handleVendorChange}
                          isMulti
                          options={factoryVendors}
                          styles={customStyles()}
                        />
                      </Stack>
                    )}

                    <Grid container spacing={2} className="mb-16">
                      <Grid item xs={6}>
                        <Stack>
                          <label>{`*${label} Id`}</label>
                          <TextField
                            className="mb-4"
                            type="text"
                            name="productId"
                            value={productId}
                            required
                            // error={(checksubmit && !productId) || validError.productId ? true : false}
                            // helperText={(checksubmit && !productId) ? "This field is required" : validError.productId}
                            onChange={(e) => {
                              setProductId(e.target.value);
                              setValidError({
                                ...validError,
                                productId: checkSpecialChar(e.target.value),
                              });
                            }}
                            variant="outlined"
                          // disabled={saveResponse}
                          // styles={customStyles()}
                          />
                          <Typography
                            mt={0}
                            className="text-[#f44336] text-sm ml-14"
                          >
                            {checksubmit && !productId?.length > 0
                              ? "This field is required"
                              : validError?.productId}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack>
                          <label>{`*${label} Name`}</label>

                          <TextField
                            className="mb-4"
                            type="text"
                            name="productName"
                            value={productName}
                            required
                            error={
                              (checksubmit && !productName) ||
                                validError.productName
                                ? true
                                : false
                            }
                            helperText={
                              checksubmit && !productName
                                ? "This field is required"
                                : validError.productName
                            }
                            onChange={(e) => setProductName(e.target.value.toUpperCase())}
                            variant="outlined"
                          // disabled={saveResponse}
                          // styles={customStyles()}
                          />
                          {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !productName?.length > 0) ? "This field is required" : validError?.productName}</Typography> */}
                        </Stack>
                      </Grid>
                    </Grid>

                    <Stack className="mb-16">
                      <label>{`${label} Valid Until`}</label>
                      <CustomDatePicker
                        format={"dd/MM/yyyy"}
                        name={"validUntil"}
                        minDate={new Date()}
                        value={validUntil}
                        handleChange={handleValidUntilChange}
                        componentsProps={{
                          actionBar: { actions: ["clear"] },
                        }}
                      />
                      <Typography
                        mt={0.5}
                        className="text-[#f44336] text-sm ml-14"
                      >
                        {validError.validUntil}
                      </Typography>
                    </Stack>

                    <Stack className="mb-16">
                      <label>{`${label} Description`}</label>
                      <TextField
                        className="mb-4"
                        type="text"
                        name="productDescription"
                        value={productDescription}
                        required
                        // error={(checksubmit && !productDescription) || validError.productDescription ? true : false}
                        // helperText={(checksubmit && !productDescription) ? "This field is required" : validError.productDescription}
                        onChange={(e) => setProductDescription(e.target.value)}
                        variant="outlined"
                        styles={customStyles()}
                      />
                      {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !productDescription?.length > 0) ? "This field is required" : validError?.productDescription}</Typography> */}
                    </Stack>

                    {productType === "ranges" && (
                      <>
                        <Stack className="mb-16">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isLacquered}
                                onChange={handleCheckboxChange}
                                className="ml-16"
                              />
                            }
                            label="Lacquered"
                          />
                        </Stack>
                        <Stack className="mb-16">
                          <label>*Select Price Group</label>
                          <Select
                            name="priceGroup"
                            value={
                              priceGroupLink &&
                              priceGroup &&
                              priceGroup.filter(
                                (obj) => priceGroupLink === obj.value
                              )
                            }
                            onChange={handlePriceGroupChange}
                            options={priceGroup}
                            styles={customStyles()}
                            className="select"
                          />
                          {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !productType) ? "This field is required" : validError.productType}</Typography> */}
                        </Stack>
                      </>
                    )}

                    <Stack className="mb-16">
                      <label>{`${label} Design year`}</label>
                      <Select
                        name="designYear"
                        value={
                          designYear &&
                          yearList &&
                          yearList.filter((q) => q.value === designYear)
                        }
                        options={yearList}
                        onChange={handleYearChange}
                        styles={customStyles()}
                        isClearable
                      ></Select>
                      {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !designYear?.length > 0) ? "This field is required" : validError?.designYear}</Typography> */}
                    </Stack>
                    {productType !== "productBundles" && (
                      <>
                        {!productImageName ? (
                          <Stack className="w-full mb-16">
                            <label>{`${label} Image Upload`}</label>
                            <Box
                              className="flex justify-center items-center"
                              sx={{
                                height: 180,
                                border: "2px dotted grey",
                              }}
                            >
                              <CloudUploadOutlinedIcon fontSize={"large"} />
                              <Typography className="ml-12">
                                Upload your image
                              </Typography>
                              <Button
                                variant="contained"
                                component="label"
                                color="secondary"
                                className="ml-12"
                              >
                                <input
                                  hidden
                                  accept="image/*"
                                  multiple
                                  type="file"
                                  onChange={(e) => handleProductImageChange(e)}
                                />
                                <Typography color="black">Browse</Typography>
                              </Button>
                            </Box>
                          </Stack>
                        ) : (
                          <Stack className="w-full mb-16">
                            <Box className="flex justify-between">
                              <Grid className="flex items-center">
                                <img
                                  src={productImage?.[0]}
                                  onError={(e) => {
                                    e.currentTarget.src = imagePlaceHolder;
                                  }}
                                  height="100px"
                                  width="100px"
                                />
                                <Typography
                                  fontSize={"large"}
                                  className="ml-12 mt-20 cursor-pointer"
                                  onClick={() => setPreviewDialog(true)}
                                >
                                  <a>{productImageName}</a>
                                </Typography>
                              </Grid>
                              <Grid>
                                <FuseSvgIcon
                                  className="mt-20 w-32 h-32 cursor-pointer"
                                  onClick={() => removeImage("range")}
                                >
                                  heroicons-outline:x
                                </FuseSvgIcon>
                              </Grid>
                            </Box>
                          </Stack>
                        )}
                      </>
                    )}
                  </FormControl>
                  <Grid container flex justifyContent={"space-between"}>
                    <Grid>
                      <FormControlLabel
                        value={active}
                        className="mb-16"
                        name="active"
                        control={<Switch color="success" />}
                        label="Active"
                        labelPlacement="start"
                        onChange={(e) => setActive(e.target.checked)}
                        checked={active ? true : false}

                      />
                      <FormControlLabel
                        value={newProduct}
                        className="mb-16"
                        name="new"
                        control={<Switch color="success" />}
                        label="New Product"
                        labelPlacement="start"
                        onChange={(e) => setNewProduct(e.target.checked)}
                        checked={newProduct ? true : false}
                      />
                    </Grid>
                    <Grid>
                      {productType === "ranges" ||
                        productType === "productBundles" || productType === "rangeVariations" ? (
                        <Button
                          variant="contained"
                          color="secondary"
                          className="ml-12"
                          disabled={disable}
                          onClick={showOption}
                        >
                          {productType === "ranges"
                            ? (id
                              ? "Update Front Options"
                              : "Add Front Options")
                            : productType === 'productBundles' ?
                              (id
                                ? "Update Bundle Products"
                                : "Add Bundle Products") :
                              (id
                                ? "Update Range Options"
                                : "Add Range Options")}
                        </Button>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            {<Grid item xs={0.5} className="flex flex-col justify-center">
              {view === 'list' && saveResponse && <Grid container direction="column" className="flex content-center">
                <Button
                  sx={{ mt: 10, mb: 1 }}
                  variant="outlined"
                  size="small"
                  onClick={handleMoveAllRight}
                  disabled={productType === 'ranges' ? frontOptionData.length === 0 : bundleProductData.length === 0}
                  aria-label="move all right"
                >
                  ≫
                </Button>
                <Button
                  sx={{ my: 1 }}
                  variant="outlined"
                  size="small"
                  onClick={handleMoveSelectedRight}
                  disabled={selectedProducts.length === 0}
                  aria-label="move selected right"
                >
                  &gt;
                </Button>
                <Button
                  sx={{ my: 1 }}
                  variant="outlined"
                  size="small"
                  onClick={handleMoveSelectedLeft}
                  disabled={selectedRowsId.length === 0}
                  aria-label="move selected left"
                >
                  &lt;
                </Button>
                <Button
                  sx={{ my: 1 }}
                  variant="outlined"
                  size="small"
                  onClick={handleMoveAllLeft}
                  disabled={productType === 'ranges' ? variationData.length === 0 : productList.length === 0}
                  aria-label="move all left"
                >
                  ≪
                </Button>
              </Grid>}
            </Grid>
            }
            {/* <Grid item xs={1}></Grid> */}
            <Grid item xs={6}>
              {id || saveResponse ? (
                <>
                  {productType === "ranges" ||
                    productType === "productBundles" || productType === "rangeVariations" ? (
                    <>
                      <div>
                        {/* {productType === 'productBundles' ? <label>Bundle products </label> : <label>Front Options </label>} */}
                        <label>Product View</label>
                        <Grid className="flex flex-row mb-10 justify-between">
                          <Grid>
                            <ToggleButtonGroup
                              value={view}
                              exclusive
                              onChange={handleViewChange}
                            >
                              <ToggleButton value="module" aria-label="module" size="small">
                                <ViewModuleIcon />
                              </ToggleButton>
                              <ToggleButton value="list" aria-label="list" size="small">
                                <ViewListIcon />
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Grid>
                          {view === "module" && (
                            <Grid>
                              <Tooltip title={"Remove Product"}>
                                <Button
                                  onClick={(e) => DeleteDialog()}
                                  variant="contained"
                                  color="warning"
                                  className="mx-auto"
                                  disabled={
                                    selectedVariation.length !== 0 ||
                                      selectedRowsId.length !== 0 ||
                                      selectedBundleProducts.length !== 0 ||
                                      selectedRanges.length !== 0
                                      ? false
                                      : true
                                  }
                                >
                                  <RemoveCircleIcon />
                                </Button>
                              </Tooltip>
                            </Grid>
                          )}
                        </Grid>
                        <div className="mb-16">
                          {productType === "ranges" ? (
                            <label>Selected Front Options</label>
                          ) : productType === 'rangeVariations' ? <label>Selected Range Options</label> : (
                            <label>Selected {productName}</label>
                          )}
                        </div>
                        <Box
                          onDrop={(event) => drop_handler(event, "right")}
                          onDragOver={(event) => dragover_handler(event)}
                          sx={{
                            overflow: "auto",
                            maxHeight: "1080px",
                          }}
                          className="flex flex-row flex-wrap"
                        >
                          <>
                            {view === "list" ? (
                              <>
                                <div
                                  className="w-full"
                                  style={{ height: "500px" }}
                                >
                                  <AgGridTable
                                    rowData={
                                      productList.length > 0
                                        ? productList
                                        : variationData.length > 0 ? variationData
                                          : rangeList
                                    }
                                    gridRef={gridRef}
                                    columnDefs={columnDefs}
                                    onSelectionChanged={onSelectionChanged}
                                    rowMultiSelectWithClick={true}
                                    editable={false}
                                    paginationPageSize={10}
                                    onGridReady={onGridReady}
                                    tableClassName={"header-cell-line"}
                                    // cellStyle={true}
                                    saveGridStateName={
                                      productType === "ranges"
                                        ? "selectedFrontOptions"
                                        : productType === "productBundles" ? 'selectBundleProduct' : 'selectedRangeOptions'
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                {saveResponse && (
                                  <Card
                                    onClick={handleOpen}
                                    className="flex justify-center items-center cursor-pointer"
                                    sx={{
                                      width: 165,
                                      height: 210,
                                      marginRight: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <Typography gutterBottom component="div">
                                      <AddIcon />
                                      {productType === "ranges"
                                        ? "Add front options"
                                        : "Drop here"}
                                    </Typography>
                                  </Card>
                                )}
                              </>
                            )}
                          </>

                          {productType === "ranges" ? (
                            <>
                              {variationData?.map((variation) => {
                                return (
                                  <FrontOptionsView
                                    key={variation.id}
                                    view={view}
                                    type={productType}
                                    product={variation}
                                    handleChangeSelected={handleChangeSelected}
                                    getVariation={getVariation}
                                  />
                                );
                              })}
                            </>
                          ) : productType === 'rangeVariations' ? (
                            <>
                              {rangeList?.map((range) => {
                                return (
                                  <FrontOptionsView
                                    key={range.id}
                                    view={view}
                                    type={productType}
                                    product={range}
                                    handleChangeSelected={handleChangeSelected}
                                  // getVariation={getVariation}
                                  />
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {productList?.map((product) => {
                                return (
                                  <FrontOptionsView
                                    key={product.id}
                                    view={view}
                                    type={productType}
                                    product={product}
                                    handleChangeSelected={handleChangeSelected}
                                  />
                                );
                              })}
                            </>
                          )}
                        </Box>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {/*-----------------variation dialog box------------------------------*/}

              <Dialog
                fullWidth={true}
                // maxWidth={'lg'}
                onClose={handleClose}
                // {...other}
                open={open}
              >
                <DialogTitle>
                  <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                    <span>{modalName}</span>
                    <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                      <Button onClick={handleClose}>
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                      </Button>
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent dividers>
                  <FormControl fullWidth>
                    <Stack>
                      <Stack className="mb-16">
                        <label>*Front Option Id</label>
                        <TextField
                          className="mb-4"
                          type="text"
                          name="productId"
                          value={variationValue.productId}
                          required
                          inputProps={{
                            maxLength: 8
                          }}
                          error={variationError.frontOptionId ? true : false}
                          helperText={variationError.frontOptionId}
                          onChange={(e) => {
                            handleVariationChange(e);
                            setVariationError({ ...variationError, frontOptionId: checkSpecialChar(e.target.value) })
                          }}
                          variant="outlined"
                          styles={customStyles()}
                        />
                        {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !variationValue.productId) ? "This field is required" : validError?.productId}</Typography> */}
                      </Stack>

                      <Stack className="mb-16">
                        <label>*Front Option Name</label>
                        <TextField
                          className="mb-4"
                          type="text"
                          name="productName"
                          value={variationValue.productName}
                          required
                          // error={(checksubmit && !variationValue.productName) || validError.variationValue.productName ? true : false}
                          // helperText={(checksubmit && !variationValue.productName) ? "This field is required" : validError.variationValue.productName}
                          onChange={(e) => {
                            handleVariationChange(e);
                          }}
                          variant="outlined"
                          styles={customStyles()}
                        />
                        {/* <Typography mt={0} className="text-[#f44336] text-sm ml-14">{(checksubmit && !variationValue.productName) ? "This field is required" : validError?.productName}</Typography> */}
                      </Stack>

                      <Stack className="mb-16">
                        <label>Select Vendor</label>
                        <Select
                          className="basic-multi-select mb-4"
                          name="name"
                          required
                          value={factoryVendors.filter((obj) =>
                            variationValue.vendor?.includes(obj.value)
                          )}
                          onChange={(e) => {
                            handleVariationChange(e, "vendor");
                          }}
                          isMulti
                          options={factoryVendors}
                          styles={customStyles()}
                        />
                      </Stack>

                      <Grid container spacing={2} className="mb-16">
                        <Grid item xs={6}>
                          <Stack>
                            <label>Front Option Color</label>
                            <TextField
                              className="mb-4"
                              type="text"
                              name="color"
                              value={variationValue.color}
                              onChange={(e) => {
                                handleVariationChange(e);
                              }}
                              variant="outlined"
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack>
                            <label>Front Option Valid Until</label>
                            <CustomDatePicker
                              format={"dd/MM/yyyy"}
                              name={"validUntil"}
                              value={variationValue.validUntil}
                              minDate={new Date()}
                              handleChange={(value) =>
                                handleVariationDateChange(value, "validUntil")
                              }
                              componentsProps={{
                                actionBar: { actions: ["clear"] },
                              }}
                            />
                            {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !validUntil) ? "This field is required" : validError.validUntil}</Typography> */}
                          </Stack>
                        </Grid>
                      </Grid>

                      {!variationImageName ? (
                        <Stack className="w-full mb-16">
                          <label>Front Option Image Upload</label>
                          <Box
                            className="flex justify-center items-center"
                            sx={{
                              height: 100,
                              border: "2px dotted grey",
                            }}
                          >
                            <CloudUploadOutlinedIcon fontSize={"large"} />
                            <Typography className="ml-12">
                              Upload your image
                            </Typography>
                            <Button
                              variant="contained"
                              component="label"
                              color="warning"
                              className="ml-12"
                            >
                              <input
                                hidden
                                accept="image/*"
                                name="imageUrl"
                                multiple
                                type="file"
                                onChange={(e) => handleVariationImageChange(e)}
                              />
                              <Typography color="black">Browse</Typography>
                            </Button>
                          </Box>
                        </Stack>
                      ) : (
                        <Stack className="w-full mb-16">
                          <Box className="flex justify-between">
                            <Grid className="flex">
                              <img
                                src={variationValue?.imageUrl?.[0]}
                                onError={(e) => {
                                  e.currentTarget.src = imagePlaceHolder;
                                }}
                                height="100px"
                                width="100px"
                              />
                              <Typography
                                fontSize={"medium"}
                                className="ml-12 mt-14 cursor-pointer"
                                onClick={() => setPreviewDialog(true)}
                              >
                                <a>{variationImageName}</a>
                              </Typography>
                            </Grid>
                            <Grid>
                              <FuseSvgIcon
                                className="mt-16 w-24 h-24 cursor-pointer"
                                onClick={() => removeImage("variation")}
                              >
                                heroicons-outline:x
                              </FuseSvgIcon>
                            </Grid>
                          </Box>
                        </Stack>
                      )}
                    </Stack>
                  </FormControl>
                  <Grid>
                    {/* \<FormControlLabel
                        value={active}
                        className="mb-16"
                        name="active"
                        control={<Switch color="success" />}
                        label="Active"
                        labelPlacement="start"
                        // onChange={(e) => setActive(e.target.checked)}
                        checked={active ? true : false}
                        disabled
                      /> */}
                    <FormControlLabel
                      value={variationValue.active}
                      className="mb-16"
                      name="active"
                      control={<Switch color="success" />}
                      label="Active"
                      labelPlacement="start"
                      onChange={(e) =>
                        setVariationValue({
                          ...variationValue,
                          [e.target.name]: e.target.checked,
                        })
                      }
                      checked={variationValue.active ? true : false}
                    />
                    <FormControlLabel
                      value={variationValue.isNew}
                      className="mb-16"
                      name="isNew"
                      control={<Switch color="success" />}
                      label="New Product"
                      labelPlacement="start"
                      onChange={(e) =>
                        setVariationValue({
                          ...variationValue,
                          [e.target?.name]: e.target.checked,
                        })
                      }
                      checked={variationValue.isNew ? true : false}
                    />
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    color="warning"
                    disabled={saveVariationDisable}
                    onClick={() => handleVariationSubmit()}
                  >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </div>
      </div>

      {/*-----------------Image Preview dialog box------------------------------*/}

      <Dialog
        fullWidth={true}
        onClose={handlePreviewClose}
        open={previewDialog}
      >
        <DialogTitle>
          <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
            <Button onClick={handlePreviewClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {open ? (
            <img src={variationValue?.imageUrl?.[0]} />
          ) : (
            <img src={productImage?.[0]} />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MaterialMasterForm;
